/* istanbul ignore file */
export const MAX_ANG_STREAM_SEARCH_RESULTS = 2000;
export const MAX_ANG_FACETS_RESULTS = 50;
export const ANG_PAGINATION_SIZE = 20;
export const SEARCH_FUNCTION_DELAY = 500;
export const MAX_ANG_STREAM_BATCH_RESULTS = 20;
export const SEARCH_QUERY_CHANGED_CODE = 2;
export const BOOST_KEY = '_boost';
export const TYPE_KEY = 'assets.@type';
export const ORGANIZATION_KEY = 'assets.AssetNode.organizationId';
export const IS_MUTABLE_KEY = 'asset-minor-versions.VersionNode.isMutable';
export const STATUS_KEY = 'asset-minor-versions.VersionNode.status';
export const UPDATED_AT_KEY = 'assets.MinorAssetNode.updatedAt';
export const CATEGORIES_KEY =
  'customer-metadata.CustomerMetadataNode.categories';
export const TAGS_KEY = 'customer-metadata.CustomerMetadataNode.tags';
export const SHARED_WITH_ME_KEY = 'sharedWithMe';
export const STREAMED_KEY = 'gui:streamed';
export const DEFAULT_SORT = 'score';
